import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Box from 'apollo-react/components/Box';
import Typography from 'apollo-react/components/Typography';
import CircularProgress from 'apollo-react/components/CircularProgress';
import './XMLViewer.css';

const XMLViewerPage = () => {
  const [searchParams] = useSearchParams();
  const fileName = searchParams.get('name') || 'XML Document';
  const xmlPath =  searchParams.get('path') || '';
  console.log('xmlPath', xmlPath);

  const [xmlContent, setXmlContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!xmlPath) {
      setError('No XML file specified');
      setLoading(false);
      return;
    }

    setXmlContent(xmlPath);

    setLoading(true);

    fetch(xmlPath)
      .then(response => {
        if (response.status === 404) {
          throw new Error(`File not found: ${fileName}`);
        }
        if (!response.ok) {
          throw new Error(`Failed to load XML (Status: ${response.status})`);
        }
        return response.text();
      })
      .then(data => {
        setXmlContent(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error loading XML:', err);
        setError(err.message);
        setLoading(false);
      });
  }, [xmlPath, fileName]);

  const formatXML = (xml) => {
    if (!xml) return '';

    // Escape HTML entities for display
    let formatted = xml
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    // Highlight XML declaration
    formatted = formatted.replace(
      /(&lt;\?xml[^?]*\?&gt;)/g,
      '<span style="color: #00f;">$1</span>'
    );

    // Highlight comments
    formatted = formatted.replace(
      /(&lt;!--[\s\S]*?--&gt;)/g,
      '<span style="color: #008000; font-style: italic;">$1</span>'
    );

    // Highlight opening and closing tags
    formatted = formatted.replace(
      /(&lt;\/?)([\w:.-]+)/g,
      '<span style="color: #800000; font-weight: bold;">$1$2</span>'
    );

    // Highlight attributes
    formatted = formatted.replace(
      /([\w:.-]+)(=)(&quot;[^&quot;]*&quot;|&#39;[^&#39;]*&#39;)/g,
      '<span style="color: #ff0000;">$1</span><span style="color: #000;">$2</span><span style="color: #0000ff;">$3</span>'
    );

    // Highlight closing brackets and self-closing tags (but not ?> from XML declarations)
    formatted = formatted.replace(
      /(?<!\?)(\/?&gt;)/g,
      '<span style="color: #800000; font-weight: bold;">$1</span>'
    );

    return formatted;
  };

  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        gap: 2
      }}>
        <CircularProgress />
        <Typography>Loading XML...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: 3,
        backgroundColor: '#f5f5f5'
      }}>
        <Typography variant="h5" color="error" gutterBottom>
          Error Loading XML
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      padding: 3
    }}>
      <Box
        className="xml-viewer-pre"
        dangerouslySetInnerHTML={{ __html: formatXML(xmlContent) }}
      />
    </Box>
  );
};

export default XMLViewerPage;

